import { useQuery } from '@tanstack/react-query';
import { paymentSettingsApi } from '../apis';

/**
 * Admin huỷ khoản user ĐÃ trả → BE hoàn sau khi trừ 規定のキャンセル料 = % cancellationConst của 料金設定 ACTIVE
 * (rule KH 2026-10-05). Ở FE chỉ dùng để XEM TRƯỚC số tiền trong confirm; số thật do BE tính lúc huỷ
 * (be: src/common/util/cancel-fee.ts — giữ cùng công thức).
 */
export const useCancellationRate = () =>
  useQuery({
    queryKey: ['payment-setting-active-cancellation-rate'],
    queryFn: () =>
      paymentSettingsApi
        .paymentSettingControllerGetByStatus('active')
        .then(({ data }) => Math.min(Math.max(Number(data?.cancellationConst ?? 0), 0), 100)),
    staleTime: 60 * 1000,
  });

const round2 = (n: number) => Number(n.toFixed(2));

export const calcCancelRefund = (chargeAmount: number, rate: number) => {
  const charge = Number(chargeAmount || 0);
  const cancelFee = round2((charge * rate) / 100);
  return { cancelFee, refundAmount: round2(Math.max(charge - cancelFee, 0)) };
};

/** Dòng giải thích trong confirm: 「キャンセル料（10%）$1.00 を差し引き、$9.00 を返金します。」 */
export const cancelRefundNote = (chargeAmount: number, rate: number) => {
  const { cancelFee, refundAmount } = calcCancelRefund(chargeAmount, rate);
  return `キャンセル料（${rate}%）$${cancelFee.toFixed(2)} を差し引き、$${refundAmount.toFixed(2)} を返金します。`;
};
